import { MagnifyingRegular } from '@ui-library/icons';
import styled from 'styled-components';
import { colorPalette } from "@ui-library/myslpro"

export const SearchBarWrapper = styled.div`
    display: flex;
    align-items: center;
    background-color: ${colorPalette.white};
    border-radius: 20px;
    padding: 6px 6px 8px 14px;
    border: 1px solid ${colorPalette.greyLight};
    width: 280px;
`;

export const SearchInput = styled.input`
    flex: 1;
    border: none;
    background-color: transparent;
    font-size: 16px;
    margin-left: 0px;

    &:focus {
        outline: none;
    }
`;

export const SearchIcon = styled(MagnifyingRegular)`
    width: 28px;
    height: 28px;
    color: ${colorPalette.greyDark};
    background-color: ${colorPalette.greyLighter};
    border-radius: 50%;
    padding: 6px;
`;